module.exports = {
  "near-black": "#1C1E28",
  "gray-light": "#f1f1f1",
  muted: "#9A9EB2",
  white: "#ffffff",
  "gray-med": "#888888",
  "gray-line": "#dddddd",
  "bright-sun": "#FFCC3E",
  "cloud-burst": "#212A51",
  "hippie-blue": "#689CB2",
  "indian-khaki": "#BDAC94",
}
